module.exports = __webpack_public_path__ + "static/img/3-3.089082d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/毕业照/3-3.jpg
// module id = v0Fm
// module chunks = 0